const styles = theme => ({
  content: {
    padding: theme.spacing(3),
  },
  container: {
    maxWidth: '640px',
    margin: '0 auto',
  },
  headerContainer: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    padding: '12px 0',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },

  header: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 36px */,
  },
  textareaContainer: {
    marginBottom: theme.spacing(1),
  },
  textarea: {
    width: '100%',
    height: '160px',
    padding: '12px',
    border: ' 1px solid var(--AI, #50A7FF)',
    borderRadius: '8px',
    backgroundColor: 'white',
    color: 'var(--mcg-dark, #002E47)',

    /* Body/Body 4 */
    fonFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
    resize: 'none',
    outline: 'none',
    fontFamily: 'inherit',
  },
  buttonRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  buttonRowLast: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(4),
  },
  ideaButton: {
    display: 'flex',
    padding: '6px 8px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    border: '1px solid var(--Border, rgba(145, 158, 171, 0.32))',
    background: 'var(--mcg-white, #FFF)',
    cursor: 'pointer',
  },
  ideaButtonSelected: {
    borderRadius: '50px',
    border: '1px solid var(--AI, #50A7FF)',
    background: 'var(--mcg-white, #FFF)',
  },

  proceedButtonContainer: {
    textAlign: 'center',
    margin: 'auto',
    width: '320px',
  },
  proceedButton: {
    width: '100%',
    maxWidth: '400px',
    padding: theme.spacing(1.5),
    backgroundColor: '#2563eb',
    color: 'white',
    fontWeight: 500,
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#1d4ed8',
    },
  },
})

export default styles
